<div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-newsletter mfp-ready" tabindex="-1"
    style="overflow: hidden auto;">
    <div class="mfp-container mfp-s-ready mfp-inline-holder">
        <div class="mfp-content">
            <div class="newsletter-popup bg-img" id="newsletter-popup-form">
                <div class="newsletter-popup-content" *ngIf="isConfirm">
                    <img [src]="companyLogo" alt="Logo" class="logo-newsletter">
                    <div class="d-flex justify-content-center store-dropdown">
                        <app-dropdown [list]="stores" displayField="StoreName" [minWidth]="200"
                            [(selectedItem)]="selectedStore">
                        </app-dropdown>
                    </div>
                    <h2>AGE VERIFICATION</h2>

                    <p>Are you <strong><span class="text-danger">19</span></strong> years old or older? Please verify
                        your age to view and purchase from the {{ CompanyName }} website.
                        Access to this website is for persons over the legal smoking age in their province or state.</p>
                    <button type="button" (click)="confirm(true)" class="btn btn-primary success"
                        [disabled]="isLoading">Yes, I AM 19+</button>
                    <button type="button" class="btn btn-primary" (click)="confirm(false)" [disabled]="isLoading">No, I
                        AM NOT 19+</button>
                </div><!-- End .newsletter-popup-content -->

                <div *ngIf="!isConfirm" class="newsletter-popup-content">
                    <h1>Sorry!</h1>
                    <p>You are not old enough to view the site ...</p>
                </div>
            </div>
        </div>
    </div>
</div>